import { css } from 'styled-components';

type TProps = {
    animateIconLeft?: boolean;
};

export const handleButtonAnimation = (animateIconLeft: TProps) => {
    if (animateIconLeft) {
        return css`
            span {
                padding-left: 4px;
                transition: all 0.3s ease-in-out;
            }

            &:hover {
                span {
                    padding-left: 0px;
                    padding-right: 12px;
                    transition: all 0.3s ease-in-out;
                }
            }
        `;
    }
};
